import React from 'react';
import { Phone, MapPin, Clock, Shield } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-zinc-950 border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <img
              src={companyInfo.logo}
              alt={companyInfo.name}
              className="h-16 w-auto object-contain mb-6"
            />
            <p className="text-gray-400 mb-6 max-w-md">
              Legacy Motorplex is your trusted partner for quality pre-owned vehicles and flexible financing options. 
              We're committed to helping you drive home in the car of your dreams.
            </p>
            <div className="flex items-center gap-2 text-gray-400">
              <Shield className="w-5 h-5 text-teal-400" />
              <span className="text-sm">Your information is secure and encrypted</span>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li>
                <a
                  href={`tel:${companyInfo.phone.replace(/[^0-9]/g, '')}`}
                  className="flex items-start gap-3 text-gray-400 hover:text-teal-400 transition-colors duration-300"
                >
                  <Phone className="w-5 h-5 text-teal-400 mt-0.5 flex-shrink-0" />
                  <div>
                    <span className="block font-medium text-white">Call Us</span>
                    <span>{companyInfo.phone}</span>
                  </div>
                </a>
              </li>
              <li>
                <a
                  href={`https://maps.google.com/?q=${encodeURIComponent(companyInfo.fullAddress)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-3 text-gray-400 hover:text-teal-400 transition-colors duration-300"
                >
                  <MapPin className="w-5 h-5 text-teal-400 mt-0.5 flex-shrink-0" />
                  <div>
                    <span className="block font-medium text-white">Visit Us</span>
                    <span>{companyInfo.address}</span>
                    <span className="block">{companyInfo.city}, {companyInfo.state} {companyInfo.zip}</span>
                  </div>
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Business Hours</h3>
            <div className="flex items-start gap-3 text-gray-400">
              <Clock className="w-5 h-5 text-teal-400 mt-0.5 flex-shrink-0" />
              <div className="space-y-2">
                <div>
                  <span className="block font-medium text-white">Mon - Sat</span>
                  <span>Appointment Only</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-zinc-800">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-sm">
              <a href="#" className="text-gray-500 hover:text-teal-400 transition-colors duration-300">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-500 hover:text-teal-400 transition-colors duration-300">
                Terms of Service
              </a>
              <a href="/admin" className="text-gray-500 hover:text-teal-400 transition-colors duration-300">
                Admin Login
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
